// extracted by mini-css-extract-plugin
module.exports = {"nested":"FluidSection_nested__1ARsB"};